import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import SelectedActionsPopup from "./SelectedActionsPopup";
import Pagination from "./Pagination";

const ReusableTable = ({
  columns,
  data,
  onSelectRow,
  columnDataTypes,
  mode,
  handleBulkAssign,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10); // Adjust the page size as needed

  useEffect(() => {
    onSelectRow(selectedRows);
  }, [selectedRows]);

  // Calculate the data to display based on the current page and page size
  const displayedData = data.slice(
    currentPage * pageSize,
    (currentPage + 1) * pageSize
  );

  const isRowSelected = (row) => {
    if (selectedRows.find((item) => item.id === row.id)) return true;
    return false;
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const totalPages = Math.ceil(data.length / pageSize);
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };
  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const toggleRowSelection = (row) => {
    if (isRowSelected(row)) {
      setSelectedRows(
        selectedRows.filter((selectedRow) => selectedRow.id !== row.id)
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((_, index) => index));
    }
  };

  const handleRejectSelected = () => {
    console.log("Rejecting selected rows:", selectedRows);
    setSnackbarMessage("The validation has been rejected!");
    setSnackbarSeverity("error");
    setShowSnackbar(true);
    setSelectedRows([]);
  };

  const handleApproveSelected = () => {
    // console.log("Approving selected rows:", selectedRows);
    // setSnackbarMessage("The validation hase been approved!");
    // setSnackbarSeverity("success");
    // setShowSnackbar(true);
    // setSelectedRows([]);
    handleBulkAssign(selectedRows);
  };

  const handleDeselectAll = () => {
    setSelectedRows([]);
  };

  // const handleLoadMore = () => {
  //   setRowsToShow(rowsToShow + 6);
  // };

  const handleSnackbarClose = () => {
    setShowSnackbar(false);
  };

  const handleUndo = () => {
    // Implement your undo logic here
    setShowSnackbar(false);
  };

  return (
    <div className="table-container">
      {/* Snackbar Component */}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Positioning
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          variant="filled"
          sx={{
            backgroundColor: "white",
            color: "#362B73",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Add boxShadow property here
            display: "flex",
            alignItems: "center", // Center items vertically
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {snackbarMessage}
            <button className="undo-button" onClick={handleUndo}>
              Undo
            </button>
          </div>
        </MuiAlert>
      </Snackbar>

      {selectedRows.length > 0 ? (
        <SelectedActionsPopup
          selectedRowsCount={selectedRows.length}
          onApproveSelected={handleApproveSelected}
          onRejectSelected={handleRejectSelected}
          onDeselectAll={handleDeselectAll}
          mode={mode}
        />
      ) : null}

      <table className="table">
        <thead>
          <tr>
            {
              <th>
                <Checkbox
                  checked={selectedRows.length === data.length}
                  onChange={handleSelectAll}
                  inputProps={{ "aria-label": "Select all rows" }}
                  disabled={mode !== "unassigned"}
                  style={{ opacity: mode !== "unassigned" ? 0 : 1 }}
                />
              </th>
            }
            {columns.map((columnName, index) => (
              <th key={index}>{columnName === "Action" ? "" : columnName}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(displayedData)
            ? displayedData.map((rowData, rowIndex) => (
                <tr key={rowIndex}>
                  {
                    <td>
                      <Checkbox
                        checked={isRowSelected(rowData)}
                        onChange={() => toggleRowSelection(rowData)}
                        inputProps={{ "aria-label": `Select row ${rowIndex}` }}
                        disabled={mode !== "unassigned"}
                        style={{ opacity: mode !== "unassigned" ? 0 : 1 }}
                      />
                    </td>
                  }
                  {columns.map((columnName, columnIndex) => (
                    <td
                      key={columnIndex}
                      className={columnDataTypes[columnIndex]}
                    >
                      {rowData[columnName]}
                    </td>
                  ))}
                </tr>
              ))
            : null}
        </tbody>
      </table>

      <Pagination
        total={data.length}
        currentPage={currentPage}
        limit={pageSize}
        updateLimit={(newLimit) => setPageSize(newLimit)}
        nextPage={() => handleNextPage()}
        prePage={() => handlePrevPage()}
      />
    </div>
  );
};

export default ReusableTable;
